(() => {
  const TARGET = "ANNNIVERSARY";
  const FIXED  = "ANNIVERSARY";

  const fixTextNodes = (root = document) => {
    // 只扫菜单区域，避免误伤页面其它文本
    const containers = root.querySelectorAll(
      'header, nav, .header, .menu-drawer, .menu, .site-nav, .dropdown, .submenu'
    );

    // 如果没找到这些容器，就退化为扫全站（但仍只改文本节点）
    const scopes = containers.length ? containers : [root];

    scopes.forEach(scope => {
      const walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, null);
      let node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue && node.nodeValue.includes(TARGET)) {
          node.nodeValue = node.nodeValue.replaceAll(TARGET, FIXED);
        }
      }
    });
  };

  // 首次
  fixTextNodes();

  // 下拉菜单/抽屉菜单动态出现时
  new MutationObserver(() => fixTextNodes()).observe(document.body, {
    childList: true,
    subtree: true,
  });

  window.addEventListener("load", () => fixTextNodes());
})();
